import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
const Layovers = ({ data }) => {
  return (
    <section className="container">
      <div className="gird grid-cols-1 py-[5vw] md:py-[1.6vw]">
        <h2
          className="text-center text-[4.8vw]  md:text-[2.35vw] font-redhatMedium"
          style={{ color: data.heading_color }}
        >
          {data.heading}
        </h2>
        <hr className="mx-auto md:w-[23.5vw] w-[12.5vw] h-[0.15vw] bg-[#F77D0D]  mb-[1.34vh]" />
        <p className="text-center text-[3.9vw] md:text-[1.34vw] text-[#090909] font-redhatMedium mt-[0.7vw]">
          {data?.description?.data?.description}
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-1 pb-[1.7vw]">
        {data.cards.map((card, index) => {
          return (
            <div
              key={index}
              className="flex flex-col md:flex-row items-stretch rounded-xl overflow-hidden "
              style={{ backgroundColor: card.card_bg_color || "#fff" }}
            >
              <div className=" text-center md:text-left  my-[0.1vw] mx-auto md:mx-0 xl:mx-0 imgDiv">
                <ImageProvider
                  className=""
                  Image={card?.card_image}
                  alt={card?.card_image?.alternativeText}
                  tailwindStyle="w-[75vw] md:w-[20.85vw] object-cover rounded-none"
                />
              </div>

              <div className="md:w-2/3 w-full p-[1.7vw] flex flex-col justify-center text-center md:text-left mx-auto md:mx-0 xl:mx-0">
                <h3
                  className="text-[#090909] text-[4.3vw] md:text-[1.19vw] mb-[0.1vw] font-redhatBold"
                  style={{ color: card.heading_color }}
                >
                  {card.heading}
                </h3>
                <p className="text-[#090909] text-[4.3vw] md:text-[1.19vw] font-redhatMedium">
                  {card?.description?.data?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Layovers;
